/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-meal-slider .swiper-pagination-bullet{width:12px;height:12px;margin:0 4px}app-meal-slider .swiper-pagination{margin:10px 1px;height:43px;position:relative}app-meal-slider .swiper-pagination .swiper-pagination-bullet{background:#fff;opacity:1;margin:0 2px}"];
export { styles as styles };
